/**
 * ValueType for "auto"
 */
var auto = {
  test: function test(v) {
    return v === "auto";
  },
  parse: function parse(v) {
    return v;
  }
};
export { auto };